__turbopack_context__.v({
  "compatibilityCard": "compatibility-module__8TAPuW__compatibilityCard",
  "compatibilityGrid": "compatibility-module__8TAPuW__compatibilityGrid",
  "compatibilityIcon": "compatibility-module__8TAPuW__compatibilityIcon",
  "compatibilitySection": "compatibility-module__8TAPuW__compatibilitySection",
  "fadeInItem": "compatibility-module__8TAPuW__fadeInItem",
});
